import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "export-import"
    }}>{`Export Import`}</h1>
    <p>{`Export Import works under a shop. So, You have to go to the `}<inlineCode parentName="p">{`shop page -> products menu`}</inlineCode>{` for product or `}<inlineCode parentName="p">{`shop page -> attributes menu`}</inlineCode>{` to import or export attributes.`}</p>
    <p><img alt="ExportImportShopPage.png" src={require("../images/ExportImportShopPage.png")} /></p>
    <p>{`Export Import work different way for simple and variable product`}</p>
    <h2 {...{
      "id": "simple-product"
    }}>{`Simple Product`}</h2>
    <p>{`For simple products, you've to export only products data. To do that, go to `}<inlineCode parentName="p">{`Your Shop -> products`}</inlineCode>{`. Then click on `}<inlineCode parentName="p">{`three dots`}</inlineCode>{` and export the simple products.`}</p>
    <p><img alt="ExportProduct.png" src={require("../images/ExportProduct.png")} /></p>
    <p>{`Similarly, for import `}<inlineCode parentName="p">{`csv,`}</inlineCode>{` go to the same option and import exported `}<inlineCode parentName="p">{`csv`}</inlineCode></p>
    <p><img alt="ImportProduct.png" src={require("../images/ImportProduct.png")} /></p>
    <h2 {...{
      "id": "variable-products"
    }}>{`variable products`}</h2>
    <p>{`For variable products, you will need three different `}<inlineCode parentName="p">{`csv.`}</inlineCode></p>
    <ul>
      <li parentName="ul">{`Attributes `}<inlineCode parentName="li">{`csv`}</inlineCode></li>
      <li parentName="ul">{`products `}<inlineCode parentName="li">{`csv`}</inlineCode></li>
      <li parentName="ul">{`variation options `}<inlineCode parentName="li">{`csv`}</inlineCode></li>
    </ul>
    <p>{`Make sure to re-import you export these three `}<inlineCode parentName="p">{`csv`}</inlineCode>{`.
`}<img alt="ExportAttrs.png" src={require("../images/ExportAttrs.png")} />{`
`}<img alt="ExportVariations.png" src={require("../images/ExportVariations.png")} />{`
`}<img alt="ExportAttrs.png" src={require("../images/ExportAttrs.png")} />{`
`}<img alt="ExportProduct.png" src={require("../images/ExportProduct.png")} /></p>
    <p>{`Now, during import variations product,
At First, you have to import Attributes
then Products and
Then products variation.
`}<img alt="ImportAttrs.png" src={require("../images/ImportAttrs.png")} />{`
`}<img alt="ImportProduct.png" src={require("../images/ImportProduct.png")} />{`
`}<img alt="ImportVariations.png" src={require("../images/ImportVariations.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`NB: Here, type_id is the brand id. You can get type info from `}<inlineCode parentName="p">{`api_url/types`}</inlineCode>{` url;`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      